import React from 'react';
import { Check } from 'lucide-react';
import { audienceItems, images } from '../../data/foundingProgram';
export function WhoItsFor() {
  return <section className="border-b border-[#D4AF37]/12 bg-[#0B0A0E]" data-id="element-1467" data-mp="1btqob147b0b1">
      <div className="mx-auto grid w-full max-w-7xl gap-12 px-5 py-20 sm:px-8 lg:grid-cols-[0.8fr_1.2fr] lg:items-center lg:gap-20" data-id="element-1468" data-mp="1psqbe4c2f753">
        <img src={images.experience} alt="A visitor surrounded by the Sikh Kingdoms immersive experience" className="aspect-[4/5] w-full border border-[#D4AF37]/25 object-cover" data-id="element-1469" data-mp="1lq20lr3sjq5h" />
        <div data-id="element-1470" data-mp="16uvt0zp1rja1">
          <p className="text-[10px] font-medium uppercase tracking-[0.32em] text-[#D4AF37]" data-id="element-1471" data-mp="16unhpc8kom0y">
            Who this is for
          </p>
          <h2 className="mt-5 font-serif text-3xl leading-tight text-[#FDFBF7] sm:text-5xl" data-id="element-1472" data-mp="123dsgcqxrkpl">
            People who want more than admiration from a distance.
          </h2>
          <ul className="mt-9 space-y-4" data-id="element-1473" data-mp="adj3wiawjz1z">
            {audienceItems.map(item => <li key={item.title} className="flex gap-4 border-b border-[#D4AF37]/10 pb-4 text-base font-light leading-relaxed text-[#FDFBF7]/70" data-id="element-1474" data-mp="w2f0r9mas503">
                <Check className="mt-1 h-4 w-4 shrink-0 text-[#D4AF37]" aria-hidden="true" data-id="element-1475" data-mp="15s8eoh9www7i" />
                {item.title}
              </li>)}
          </ul>
          <p className="mt-8 font-serif text-2xl leading-snug text-[#D4AF37]" data-id="element-1476" data-mp="d42ubvmrt987">
            You do not need to be an expert, only someone who believes this
            story deserves to be experienced.
          </p>
        </div>
      </div>
    </section>;
}